<div class="mui-pagination__size">
  <label [id]="sizeSelect.labelId()" class="me-auto me-md-2">{{ sizeSelectLabel ?? (translations$ | async)?.sizeSelectLabel }}</label>
  <mui-select
    [closeOnSelect]="true" [ngModel]="size" (ngModelChange)="changeSize($event)"
    #sizeSelect="muiSelect"
    class="mui-pagination__size-select">
    <mui-option *ngFor="let opt of sizeOptions" [value]="opt" [label]="opt">{{ opt }}</mui-option>
  </mui-select>
</div>
<div class="mui-pagination__page">
  <div class="me-auto me-md-2">{{ displayedItemsLabel ?? (translations$ | async)?.displayedItemsLabel }}</div>
  <button
    mui-icon-btn font="fa" icon="chevron-left" appearance="ghost"
    (click)="previousPage()"
    [disabled]="isFirstPage"
    [label]="previousPageButtonLabel ?? (translations$ | async)?.previousPageButton"></button>
  <button
    mui-icon-btn font="fa" icon="chevron-right" appearance="ghost"
    (click)="nextPage()"
    [disabled]="isLastPage"
    [label]="nextPageButtonLabel  ?? (translations$ | async)?.nextPageButton"></button>
</div>
